export const GRETA_AI_CHAT_CHAT_LIST_ITEM_SUBTITLE_SEPARATOR = ' · '
